document.addEventListener('DOMContentLoaded', function () {
  var section = document.getElementById('fc-legends-section');
  var grid = document.getElementById('fc-legends-grid');

  if (!section) return;

  if ('IntersectionObserver' in window) {
    var bgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fc-bg-visible');
        } else {
          entry.target.classList.remove('fc-bg-visible');
        }
      });
    }, { threshold: 0, rootMargin: '-10% 0px -10% 0px' });

    bgObserver.observe(section);
  } else {
    section.classList.add('fc-bg-visible');
  }

  if (grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.fc-legend-card'));

    cards.forEach(function (card, index) {
      card.style.transitionDelay = (index * 90) + 'ms';
    });

    if ('IntersectionObserver' in window) {
      var cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      }, { threshold: 0.15 });

      cards.forEach(function (card) {
        cardObserver.observe(card);
      });
    } else {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
    }
  }
});